import { useMediaPlayerContext } from "./context";
import { MediaProgressBuffered } from "./MediaProgressBuffered";
import { MediaProgressValue } from "./MediaProgressValue";

export interface MediaProgressGroupProps {
  end?: number;
  playheadValue?: number;
  pointerValue?: number;
  start?: number;
}

export function MediaProgressGroup({
  end,
  playheadValue = 0,
  pointerValue = 0,
  start,
}: MediaProgressGroupProps) {
  const { buffered } = useMediaPlayerContext();

  return (
    <div className="MediaProgressGroup">
      {/* hover progress */}
      <MediaProgressValue value={pointerValue} />

      {/* buffered progress */}
      {Boolean(buffered) && <MediaProgressBuffered start={start} end={end} />}

      {/* currentTime/scrubbing progress */}
      <MediaProgressValue value={playheadValue} primary />
    </div>
  );
}
